export type ColorScheme =
  | "default"
  | "navy"
  | "neutral"
  | "neutral-light"
  | "steel-blue"
  | "mint"
  | "teal-dark";

export interface SchemeClasses {
  /** Tailwind bg utility */
  bg: string;
  /** Tailwind text utility for headings */
  heading: string;
  /** Tailwind text utility for body copy */
  body: string;
  /** Tailwind text utility for muted / secondary body copy */
  bodyMuted: string;
  /** Hex for editor swatch */
  swatch: string;
  /** Human-readable label */
  label: string;
  /** Optional overrides applied when the element is in an active/expanded state. */
  active?: Partial<
    Pick<SchemeClasses, "bg" | "heading" | "body" | "bodyMuted">
  >;
  /** Optional overrides applied when the element is in an inactive/collapsed state. */
  inactive?: Partial<
    Pick<SchemeClasses, "bg" | "heading" | "body" | "bodyMuted">
  >;
}

export const COLOR_SCHEMES: Record<ColorScheme, SchemeClasses> = {
  default: {
    bg: "bg-white",
    heading: "text-navy",
    body: "text-navy",
    bodyMuted: "text-navy",
    swatch: "#ffffff",
    label: "Default",
  },
  navy: {
    bg: "bg-navy",
    heading: "text-white",
    body: "text-white",
    bodyMuted: "text-white",
    swatch: "#092c48",
    label: "Navy",
  },
  neutral: {
    bg: "bg-neutral-cool",
    heading: "text-navy",
    body: "text-navy",
    bodyMuted: "text-navy",
    swatch: "#bed3e0",
    label: "Neutral",
  },
  "neutral-light": {
    bg: "bg-neutral-cool-light",
    heading: "text-navy",
    body: "text-navy",
    bodyMuted: "text-navy",
    swatch: "#e8eef2",
    label: "Neutral Light",
  },
  "steel-blue": {
    bg: "bg-[#19557f]",
    heading: "text-white",
    body: "text-white",
    bodyMuted: "text-white",
    swatch: "#19557f",
    label: "Steel Blue",
  },
  mint: {
    bg: "bg-accent-mint-tint",
    heading: "text-navy",
    body: "text-navy",
    bodyMuted: "text-navy",
    swatch: "#effafb",
    label: "Mint",
  },
  "teal-dark": {
    bg: "bg-teal-dark",
    heading: "text-white",
    body: "text-white",
    bodyMuted: "text-white",
    swatch: "#007C85",
    label: "Teal Dark",
    active: {
      bg: "bg-teal-dark",
      heading: "text-white",
      body: "text-white",
      bodyMuted: "text-white",
    },
    inactive: {
      bg: "bg-accent-mint-tint-1",
      heading: "text-navy",
      body: "text-navy",
      bodyMuted: "text-navy",
    },
  },
};
